import React, { Component } from "react";
import Slider from "react-slick";

export default class BannerSlider extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
        };
        return (
            <div>
                <Slider {...settings}>
                    <div>
                        <div className="saas_home_img">
                            <img
                                src={require("../../img/seo/instant_auto_cash.png")}
                                alt=""
                            />
                        </div>
                    </div>
                </Slider>
            </div>
        );
    }
}
